module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEXRSTlMADKsoPJ8Ew//n879T+8sY13W/vG8AAAEBSURBVHgB7daxAcJAEAPBxxh4DBj6r5ZEibObzMGpgJ1Uo9fr9Xq93rl3Wa6jvPV25/5jPsvCus3lzv1ZEtKfJKQfodSPgP0ItT4JrzlrQvrZrQy8P0Xh0N/WkbngfRe874L3XfC+C953wfsueB8F75vgfRO8b4L3TfC+Cd43wfsmeB8F76PgfRe874L3UfA+Cd6HfwWPzPsueN8F76vgfRC8v31I8P76JsH7Y5jgfRO8b4L3TfC+Cd43wfsmeB8F77vgfRe874L3XfC+C953wfsuZHu1fxSWMvD91fpH4XEZIFT7EdIXodaPkL4JtX6E9EnYS/0Ir/R7vV6v1+uddX+z4icAfdG+MQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-white-icon.png
// module id = 64
// module chunks = 0